'use client'

import { useEffect, useState } from 'react'
import DOMPurify from 'isomorphic-dompurify'

export const IngredientSteps = ({ ingredient }: any) => {
  const ingredientsTabs = [
    { id: 1, label: 'Cooking Guide', desc: ingredient?.cookingGuidance },
    { id: 2, label: 'Choosing', desc: ingredient?.choosing },
    { id: 3, label: 'Preparation', desc: ingredient?.preparation },
    { id: 4, label: 'Pairing', desc: ingredient?.pairing },
    { id: 5, label: 'Methods', desc: ingredient?.methods },
  ].filter((tab) => tab.desc?.trim())

  const [activeTab, setActiveTab] = useState(ingredientsTabs[0]?.id ?? 1)
  const [animKey, setAnimKey] = useState(0)

  useEffect(() => {
    if (!ingredientsTabs.some((t) => t.id === activeTab) && ingredientsTabs[0]) {
      setActiveTab(ingredientsTabs[0].id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ingredient?.ingredient_id])

  if (ingredientsTabs.length === 0) {
    return null
  }

  const active = ingredientsTabs.find((t) => t.id === activeTab) ?? ingredientsTabs[0]

  const selectTab = (id: number) => {
    if (id === activeTab) return
    setActiveTab(id)
    setAnimKey((k) => k + 1)
  }

  return (
    <div className="flex flex-col gap-6">
      <div
        role="tablist"
        aria-label="Ingredient guide"
        className="flex w-full overflow-x-auto text-center"
      >
        {ingredientsTabs.map((tab) => {
          const isActive = activeTab === tab.id
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => selectTab(tab.id)}
              className={`flex min-w-[120px] flex-1 shrink-0 flex-col items-center gap-[17px] text-base leading-[120%] tracking-[-0.04em] transition-colors md:text-[18px] ${
                isActive
                  ? 'font-semibold text-[#85C349]'
                  : 'font-medium text-[#202020] hover:text-[#548828]'
              }`}
            >
              <span className="px-2">{tab.label}</span>
              <span
                aria-hidden="true"
                className={`block w-full ${isActive ? 'h-[2px] bg-[#85C349]' : 'h-px bg-[#CBD7DD]'}`}
              />
            </button>
          )
        })}
      </div>

      <div
        key={`${active.id}-${animKey}`}
        role="tabpanel"
        aria-label={active.label}
        className="rounded-xl border border-[#F3FAEB] bg-[#F7F7F7] p-4 text-base leading-[150%] text-[#202020] md:text-[18px]"
        style={{
          animation: 'ingredientTabIn 280ms ease-out, ingredientTabFlash 700ms ease-out',
        }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(active.desc ?? '') }}
        />
      </div>
    </div>
  )
}
